import PropTypes from "prop-types";
import { injectIntl, defineMessages } from "react-intl";
import { Card, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import StatusBadge from "./StatusBadge";
import MessageStatus from "./MessageStatus";
import { jobFetchJob } from "../services/job";
import * as Sentry from "@sentry/react";
import { useNavigate } from "react-router-dom";

// translations
export const messages = defineMessages({
    authError: {
        id: 'Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen.',
        defaultMessage: 'Tunnistautuminen epäonnistui. Ole hyvä ja yritä uudelleen.'
    },
    pleaseTryAgain: {
        id: "Tapahtui virhe. Ole hyvä ja yritä uudelleen.",
        defaultMessage: "Tapahtui virhe. Ole hyvä ja yritä uudelleen."
    },
    jobNotFound: {
        id: "Virheelliset hakutiedot. Haku lukitaan viiden virheellisen haun jälkeen.",
        defaultMessage: "Virheelliset hakutiedot. Haku lukitaan viiden virheellisen haun jälkeen."
    },
    forbiddenError: {
        id: "Haku estetty.",
        defaultMessage: "Haku estetty."
    },
    searchLocked: {
        id: "Liian monta virheellistä hakua. Turvallisuussyistä haku on lukittu 30 minuutiksi.",
        defaultMessage: "Liian monta virheellistä hakua. Turvallisuussyistä haku on lukittu 30 minuutiksi."
    },
    notAllowedToSign: {
        id: "Ei nimenkirjoitusoikeutta.",
        defaultMessage: "Ei nimenkirjoitusoikeutta."
    },
    invoice: {
        id: "Lasku",
        defaultMessage: "Lasku"
    },
    unreadMessage: {
        id: "Uusi lukematon viesti",
        defaultMessage: "Uusi lukematon viesti"
    },
    openInvoice: {
        id: "Avaa lasku",
        defaultMessage: "Avaa lasku"
    }
});

const MessageCard = (props) => {

    const lng = props.intl.formatMessage;
    const navigate = useNavigate();

    const id = props.message?.id;
    const status = props.message?.current_status?.status;
    const statusCode = props.message?.jobstatus;
    const dueDate = props.message?.due_date;
    const summary = props.message?.summary;
    const invoiceNumber = props.message?.jobid;
    const invoiceDpid = props.message?.dpid;
    const creditor = props.message?.creditor;
    const isUnread = props.message?.current_status?.unread;

    const handleInvoiceClick = async (e) => {
        e.preventDefault();

        jobFetchJob(invoiceDpid)
            .then(function () {
                navigate("/job");
            })
            .catch(function (error) {
                Sentry.captureException(error);
                // response exists
                if (typeof error?.response !== 'undefined') {
                    if (error.response.status === 401) {
                        // authentication failed, redirect back to authentication
                        const alert = { message: lng(messages.authError), type: 'danger' };
                        navigate("/logout", { state: { alert }});
                    } else if (error.response.status === 403) {

                        // Forbidden messages
                        let message = lng(messages.forbiddenError);

                        if (typeof error.response.data.Message !== 'undefined') {
                            if (error.response.data.Message === 'Online access log - user access denied') {
                                message = lng(messages.searchLocked);
                            } else if (error.response.data.Message === 'Online jobsearch - company person is not allowed to sign') {
                                message = lng(messages.notAllowedToSign);
                            }
                        }

                        props.showAlerts({
                            message: message,
                            type: 'light',
                        });
                    } else {
                        props.showAlerts({
                            message: lng(messages.jobNotFound),
                            type: 'light',
                        });
                    }
                } else {
                    props.showAlerts({
                        message: lng(messages.pleaseTryAgain),
                        type: 'light',
                    });
                }
            });
    }

    return (
        <Card key={'messagecard-' + id} className={'fullwidth-mobile messagecard grey-bottom-border-mobile' + (props.active ? ' chosen ' : '')}>
            <Card.Body className="p-4">
                <Row>
                    <Col xs={12} className="mb-2">
                        <StatusBadge statusCode={statusCode} dueDate={dueDate} />
                        {statusCode !== undefined && <span className="me-1" />}
                        <MessageStatus originalStatus={status} />
                        {!!isUnread && (
                            <FontAwesomeIcon
                                className="message-center-new-messages text-danger"
                                icon={fas.faCircle}
                                aria-label={lng(messages.unreadMessage)}
                            />
                        )}
                    </Col>
                    <Col xs={12} className="mb-2">
                        <h5 className="mb-0">{summary}</h5>
                    </Col>
                    {!props.hideInvoiceLink && (
                    <Col xs={12}>
                        <p className="fs-6 mb-0">
                            <button
                                className="btn btn-link-style"
                                onClick={handleInvoiceClick}
                                type='button'
                                aria-label={lng(messages.openInvoice) + ' ' + invoiceNumber}
                            >
                                {lng(messages.invoice)} #{invoiceNumber}
                            </button>
                            <span className="text-muted ms-2"> {creditor}</span>
                        </p>
                    </Col>
                    )}
                </Row>
            </Card.Body>
        </Card >
    );
}

MessageCard.propTypes = {
    'intl': PropTypes.object,
    'message': PropTypes.object,
    'active': PropTypes.bool,
    'showAlerts': PropTypes.func,
    'hideInvoiceLink': PropTypes.bool
};

export default injectIntl(MessageCard);